import {Routes} from '@angular/router';

import {requireEmailVerified} from './guard-helpers';

export const profileRoutes: Routes = [
	{
		path: 'profile',
		canActivate: [requireEmailVerified],
		loadComponent: () => import('../pages/profile/profile-page.component').then((c) => c.ProfilePageComponent)
	},
	{
		path: 'visitor/:username',
		canActivate: [requireEmailVerified],
		pathMatch: 'prefix',
		loadComponent: () => import('../pages/profile/visitor/visitor-page.component').then((c) => c.VisitorPageComponent)
	},
	{
		path: 'settings',
		canActivate: [requireEmailVerified],
		loadComponent: () => import('../pages/settings/settings.component').then((c) => c.SettingsComponent)
	},
	{
		path: 'profile-set',
		canActivate: [requireEmailVerified],
		loadComponent: () => import('../pages/profile-set/profile-set.component').then((c) => c.ProfileSetComponent)
	},
	{
		path: 'onboarding',
		canActivate: [requireEmailVerified],
		loadComponent: () => import('../pages/onboarding/onboarding-page.component').then((c) => c.OnboardingPageComponent)
	},
	{
		path: 'home',
		canActivate: [requireEmailVerified],
		loadComponent: () => import('../pages/home/home-page.component').then((c) => c.HomePageComponent)
	},
	{
		path: 'subscription',
		canActivate: [requireEmailVerified],
		loadComponent: () => import('../pages/subscription/subscription-page.component').then((c) => c.SubscriptionPageComponent)
	},
	{
		path: 'safety-center',
		canActivate: [requireEmailVerified],
		loadComponent: () => import('../pages/safety-center/safety-center-page.component').then((c) => c.SafetyCenterPageComponent)
	},
	{
		path: 'report',
		canActivate: [requireEmailVerified],
		loadComponent: () => import('../pages/report-create/report-create-page.component').then((c) => c.ReportCreatePageComponent)
	},
	{
		path: 'reports',
		canActivate: [requireEmailVerified],
		loadComponent: () => import('../pages/reports/reports-page.component').then((c) => c.ReportsPageComponent)
	}
];
